var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg121 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BEE4F8",
  d: "M6.882 7.396c1.12 0 2.174.285 3.094.785a9.24 9.24 0 0 0-3.26 6.297h-.532A6.18 6.18 0 0 0 1.2 17a6.483 6.483 0 0 1 5.682-9.604"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15.945 7.496a7.77 7.77 0 0 1 6.775 3.963 7.1 7.1 0 0 0-4.292 5.919h-.408c-2.627 0-4.755 2.12-4.755 4.734 0 1.252.489 2.391 1.287 3.238H6.184a4.687 4.687 0 0 1-.214-9.371l.214-.005h1.907l.115-1.37a7.77 7.77 0 0 1 7.74-7.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.524 12.383a5.625 5.625 0 0 1 5.306 3.731l.415 1.169 1.225-.191q.322-.05.655-.05c2.309 0 4.178 1.86 4.178 4.153s-1.87 4.155-4.178 4.155H18.02a3.25 3.25 0 0 1-3.258-3.238 3.25 3.25 0 0 1 3.258-3.238h1.783l.116-1.37c.243-2.883 2.675-5.12 5.605-5.12M21.743 35.724a2.792 2.792 0 1 1-5.317-1.194l1.563-3.979c.53-1.35 1.39-1.35 1.921 0l1.557 3.96c.182.379.277.793.276 1.213"
}))));
export { Svg121 as ReactComponent };